import { IZone } from 'core/model/interfaces/master-entities';
import type { TSliceReducer } from 'core/store';
import { initialState } from './constants';
import type { IZonesState } from './types';

export const clearZonesState: TSliceReducer<IZonesState> = state => {
  Object.assign(state, initialState);
};

export const setZones: TSliceReducer<IZonesState, Array<IZone>> = (state, { payload }) => {
  state.zones = payload;
};

export const reducers = { clearZonesState, setZones };
